const APP_NAME = 'Recipes Share';

export default APP_NAME;
